import styled from '@emotion/styled'
import { Text } from 'components/Typography'
import { BREAKPOINTS } from 'utils/styled'

export const STitleRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;

  svg {
    width: 1.5rem;
    height: 1.5rem;
    margin-right: 0.75rem;

    & > * {
      stroke: black;
    }
  }
`

export const SDescription = styled(Text)`
  margin-bottom: 1.5rem;
`

export const SCardsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1.5rem;
`

export const STemplateName = styled(Text)`
  color: var(--c-gray100);
`

export const SBlankWrapper = styled.div`
  display: flex;
  height: 100%;
  border: 2px solid var(--c-blue100);
  align-items: center;
  justify-content: center;
  border-radius: 2px;

  transition: border-color 0.3s ease;
`

export const SCardWrapper = styled.div`
  cursor: pointer;

  &:hover {
    ${STemplateName} {
      text-decoration: underline;
    }

    ${SBlankWrapper} {
      border-color: var(--c-blue200);
    }
  }
`

export const SCardImageWrapper = styled.div`
  height: 14rem;
  margin-bottom: 0.75rem;

  @media ${BREAKPOINTS.MD.max} {
    height: 8.75rem;
  }
`

export const SImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 2px;
`
